/**
 * @file frontend/src/lib/utils.js
 * @module lib
 * @component utils
 *
 * Utils — Shared library / API client code.
 *
 * Responsibilities:
 *   - Render the primary UI for this surface.
 *   - Coordinate API calls and local state.
 *   - Emit user actions to parent components / context where applicable.
 *
 * Notes:
 *   - All API calls go through the shared axios client (REACT_APP_BACKEND_URL).
 *   - Side effects belong in `useEffect`; keep render pure.
 */
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Returns the UTC ISO string that equals midnight on the given YYYY-MM-DD date
// in America/Chicago time. Use this instead of bare date strings for clock_in__gte
// / clock_in__lte API params — Django datetime filters interpret plain dates as
// UTC midnight, which cuts off CDT evening entries.
export function chicagoMidnightUTC(dateStr) {
  const [y, m, d] = dateStr.split('-').map(Number);
  const probe = new Date(Date.UTC(y, m - 1, d, 0, 0, 0));
  const chicagoHour = parseInt(
    new Intl.DateTimeFormat('en-US', { timeZone: 'America/Chicago', hour: 'numeric', hour12: false }).format(probe), 10
  );
  const offsetHours = (24 - chicagoHour) % 24;
  return new Date(Date.UTC(y, m - 1, d, offsetHours, 0, 0)).toISOString();
}
